import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavbarComponent } from '../../navbar/navbar.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-gdc-navbar',
  imports: [NavbarComponent],
  templateUrl: './gdc-navbar.component.html',
})
export class GdcNavbarComponent {}
